import { render } from "./Apply.vue?vue&type=template&id=37d8d822"
import script from "./Apply.vue?vue&type=script&lang=ts"
export * from "./Apply.vue?vue&type=script&lang=ts"
script.render = render

export default script